// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"v--z","button":"w--z","disabled":"x--z","creditCard":"y--z","wrapper":"z--z"};